declare global {
  interface Window {
    dataLayer?: Record<string, any>[]
  }
}

interface Product {
  name: string;
  position: number;
}

function formatProducts(selectedProducts: Product[]) {
  return selectedProducts?.map(product => ({
    brand: 'Veuve Clicquot',
    category: 'champagne',
    id: undefined,
    isCustomizable: undefined,
    name: product.name,
    position: product.position,
    price: undefined,
    productFlag: undefined,
    productFormat: undefined,
    productMidCategory: undefined,
    productStock: undefined,
    productType: undefined,
    variant: undefined
  }))
}
//exports
export function gtm_eeListView(listName: string, listStyle: string, productsList: Product[], allowed: boolean = true) {
  if (!allowed) return
  window.dataLayer = window.dataLayer || []
  const formattedProducts = formatProducts(productsList)
  const output = {
    event: 'eeListView',
    currencyCode: undefined,
    listName: listName,
    listType: listStyle,
    products: formattedProducts
  }
  console.warn('gtm-manager - eeListView', output)
  window.dataLayer.push(output)
}

export function gtm_eeListClick(listName: string, listStyle: string, product: Product, allowed: boolean = true) {
  if (!allowed) return
    window.dataLayer = window.dataLayer || []
    const formattedProducts = formatProducts([product])
    const output = {
      event: 'eeListClick',
      currencyCode: undefined,
      listName: listName,
      listType: listStyle,
      products: formattedProducts
    }
    console.warn('eeListClick', output)
    window.dataLayer.push(output)
}

export function gtm_click(cta_name:string, allowed: boolean = true) {
  if (!allowed) return
  window.dataLayer = window.dataLayer || [];
  console.warn('gift_finder_click', cta_name)
  window.dataLayer.push({
      event: 'gift_finder_click',
      cta_name: cta_name
  })
}

export function gtm_eretailer_outbound_click(eretailer_name: string, product_name?: string, isAllowed: boolean = true) {
  if (!isAllowed) return
    window.dataLayer = window.dataLayer || []
    console.warn('gtm-manager - eretailer_outbound_click', eretailer_name, product_name)
    window.dataLayer.push({
      event: 'eretailer_outbound_click',
      eretailer_name: eretailer_name,
      product_name: product_name || undefined
    })
}
const gtmId = import.meta.env.VITE_GTM || 'GTM-KXP3GVBD'

export const load_gtm = (isAllowed: boolean = true) => {
  const head = document.head.getElementsByTagName('script')
  const isLoaded = Array.from(head).some(el =>  el.src.includes('google') || el.innerHTML.includes('gtm'))
  console.log('gtm-manager - isLoaded', isLoaded)
  console.log('gtm-manager - isAllowed', isAllowed)
  if (!isLoaded && isAllowed) {
    console.log('gtm-manager - loading GTM', gtmId)
    const gtmScript = document.createElement('script')
    gtmScript.async = true
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
    document.head.appendChild(gtmScript)

    const noscript = document.createElement('noscript')
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    document.body.appendChild(noscript)

    const gtmScript2 = document.createElement('script')
    gtmScript2.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`
    document.head.appendChild(gtmScript2)
  }
}
